exports.cs = {
  FIELD: {
    INVALID_INPUT: 'Error.',
    ERROR_REQUIRED: 'Please fill in.',
    TOOLTIP_CISLO_UCTU: 'Correct format consists from prefix, account number and bank code. If there is no prefix, fill in zeros.',
    INVALID_ACCOUNT_NUMBER: 'Invalid account number.',
    INVALID_ACCOUNT_PREFIX: 'Invalid account prefix.',
    INVALID_BANK_CODE: 'Invalid bank code.',
    INVALID_PASTE_ACCOUNT_FORMAT: 'Pasted invalid account number format.'
  }
}
